import React, { useContext, useEffect } from 'react'
import { Box, Text, useResponsiveWrapperContext } from '@usap/uicomponents'
import { useFeatureFlagCookieContext } from '@usap/core'
import { LocalContext } from '../../../../helpers/useLocalContext'
import { formatBrand } from "../../../../transformers/BrandText";

export default function Title(props) {
  const {
    sku,
    title,
    brand,
    link = '#',
    skip,
    index,
    onClick = () => {},
  } = props

  const { localContext } = useContext(LocalContext)
  const { Link } = localContext
  const { isDesktop } = useResponsiveWrapperContext()

  const { fullTitleCookie: showFullTitle } = useFeatureFlagCookieContext()

  useEffect(() => {
    const showTruncateTitle = Boolean(!showFullTitle)

    if (showTruncateTitle) {
      const titleArray = title.split(' ')
      const lines = 2
      const lineHeight = 1.6 * 14
      const truncateElement = document.getElementById(`productTitle-${sku}-${index}`)

      while (lines * lineHeight < truncateElement.offsetHeight) {
        titleArray.pop()
        truncateElement.innerHTML = `${titleArray.join(' ')}...`
        truncateElement.parentNode.title = title
      }
    } else {
      const skuTitles = document.getElementsByClassName('productTitle')
      const skuRatings = document.getElementsByClassName('productRating')

      if (isDesktop && skuTitles.length > 1 && skuRatings.length > 1) {
        let maxHeight = skuTitles[0].offsetHeight

        for (let i = 0; i < skuTitles.length; i += 1) {
          // eslint-disable-next-line security/detect-object-injection
          let elem = skuTitles[i]
          if (i % 3 === 0 || elem.offsetHeight > maxHeight) {
            maxHeight = elem.offsetHeight
          }
          const rem = (i+1) % 3
          if (rem === 0 || i+1 === skuTitles.length) {
            let productRowCtr = rem === 0 ? 3 : rem

            // eslint-disable-next-line max-depth
            for (let j = i; productRowCtr > 0; j -= 1, productRowCtr -= 1) {
              // eslint-disable-next-line security/detect-object-injection
              elem = skuRatings[j]
              // eslint-disable-next-line security/detect-object-injection
              const filler = maxHeight - skuTitles[j].offsetHeight
              elem.style.paddingBottom = `${filler}px`
            }
          }
        }
      }
    }
  }, [index, isDesktop, showFullTitle, sku, title])

  const wrapperStyle = showFullTitle ? {} : { height: '74px', overflow: 'hidden' }

  return (
    <Box
      width="100%"
      style={{ ...wrapperStyle }}
    >
      <Link
        to={link}
        skip={skip}
        onClick={onClick}
        style={{ lineHeight: '20px' }}
        aria-label={`${brand} ${title}-${sku}-${index}`}
      >
        <Box width="100%">
          <Text weight={700} size="20px" color="dark-2">
            {formatBrand(brand)}
          </Text>
        </Box>
        <Text
          id={`productTitle-${sku}-${index}`}
          size="small"
          color="dark-2"
          className="productTitle"
        >
          {title}
        </Text>
      </Link>
    </Box>
  )
}
